(function () {
  if (window.s365CopyBound) return
  window.s365CopyBound = true
  function fallbackCopy (text) {
    const ta = document.createElement('textarea')
    ta.value = text
    ta.setAttribute('readonly', '')
    ta.style.position = 'fixed'
    ta.style.opacity = '0'
    document.body.appendChild(ta)
    ta.select()
    try { document.execCommand('copy') } catch (e) {}
    document.body.removeChild(ta)
  }
  function markDone (btn, text) {
    const label = btn.querySelector('[data-s365-copy-label]')
    const live = btn.parentElement ? btn.parentElement.querySelector('[data-s365-copy-live]') : null
    if (label && !label.dataset.original) label.dataset.original = label.textContent
    if (label) label.textContent = label.dataset.done
    btn.classList.add('is-copied')
    if (live) {
      live.textContent = ''
      requestAnimationFrame(function () { live.textContent = label ? label.dataset.done : text })
    }
    clearTimeout(btn.s365Timer)
    btn.s365Timer = setTimeout(function () {
      if (label) label.textContent = label.dataset.original
      btn.classList.remove('is-copied')
    }, 2000)
  }
  document.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-s365-copy]')
    if (!btn) return
    const text = btn.getAttribute('data-s365-copy')
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(function () { markDone(btn, text) }, function () {
        fallbackCopy(text)
        markDone(btn, text)
      })
    } else {
      fallbackCopy(text)
      markDone(btn, text)
    }
  })
})()
